<template>
  <v-card
    :style="`height: calc(100vh - 74px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
    class="col-12 pb-0"
  >
    <v-row
      class="mx-0 px-2"
    >
      <select-project
        v-model="project"
        class="package-project_selector"
        style="max-width: 200px"
      >
      </select-project>

      <v-combobox
        :items="accounts"
        :loading="searching"
        class="col"
        hide-details
        style="max-width: 250px"
        label="Search..."
        autocomplete="off"
        auto-select-first
        v-model="accountSearch"
        @input="setSearch"
        @input.native="setSearch"
      />


      <date-picker
        v-model="from"
        label="Date From"
        style="max-width: 140px"
      />

      <date-picker
        v-model="to"
        label="Date To"
        style="max-width: 140px"
      />

      <v-btn
        color="info"
        class="mt-3 ml-3"
        :loading="loading"
        :disabled="loading"
        @click="search"
      >
        Search
      </v-btn>
      <export :fields="exportFields" without_sg :data="items" report-name="Packages for Approve" :project="project" />
    </v-row>

    <v-data-table
      :class="`bonus-tools-dt ${$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) ? 'padding-footer' : ''}`"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      fixed-header
      item-key="package_id"
      :expanded.sync="expanded"
      show-expand
      :options.sync="options"
      :items="filteredItems"
      :footer-props="{'items-per-page-options':[ 50, 100, 200 ]}"
      :items-per-page="50"
      :height="`calc(100vh - 215px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
          <td
            v-for="header in headers"
            :key="header.value"
            style="height: auto"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="ma-0 pa-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="ma-0 pa-0"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{width: (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>


      <template v-slot:item.login="{ item, header }">
        <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
      </template>
      <template v-slot:item.account_id="{ item, header }">
        <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
      </template>

      <template v-slot:expanded-item="{ headers , item }">
        <td :colspan="headers.length">

          <v-row class="col-12 px-0 mx-0">
            <v-col cols="6" class="pl-0">
              <fieldset class="px-2 pb-2 group-border">
                <legend class="px-2">Choices</legend>
                <v-container class="pa-0 ma-0" v-for="(choice, i) in item.rules.choices" :key="'bt-choice-' + i">
                  <v-divider v-if="i > 0" class="my-4" />
                  <v-card v-for="(bonus, k) in choice.bonuses" :key="'bt-choice-bonus-' + k" class="mt-2">
                    <v-card-text :class="{'pt-2': true, 'pb-2': bonus.type == 'loyalty'}">
                      <v-row>
                        <v-text-field
                          class="col-3"
                          label="Type"
                          :value="bonus.type"
                          hide-details
                          readonly
                        />

                        <v-text-field
                          class="col-2"
                          label="Amount"
                          :value="bonus.amount || (bonus.percent + '%')"
                          :suffix="['casino','sport','cash_bonus', 'loyalty'].includes(bonus.type) && bonus.amount ? item.currency : false"
                          hide-details
                          readonly
                        />

                        <v-text-field
                          class="col-2"
                          v-if="bonus.hasOwnProperty('wager')"
                          label="Wager"
                          :value="bonus.wager"
                          hide-details
                          readonly
                        />

                        <v-select
                          v-if="bonus.hasOwnProperty('game_id')"
                          class="col"
                          label="Game"
                          :value="bonus.game_id"
                          :prefix="'#' + bonus.game_id"
                          :items="games"
                          hide-details
                          readonly
                        />

                        <v-checkbox
                          :class="{'mr-3': true, 'mt-0': bonus.hasOwnProperty('game_id'), 'ml-3': bonus.hasOwnProperty('game_id')}"
                          v-if="bonus.hasOwnProperty('brand_exclusive')"
                          label="Exclusive Brand"
                          :value="bonus.brand_exclusive"
                          hide-details
                          readonly
                        />

                        <v-checkbox
                          :class="{'mt-0': bonus.hasOwnProperty('game_id')}"
                          v-if="bonus.hasOwnProperty('game_exclusive')"
                          label="Exclusive Game"
                          :value="bonus.game_exclusive"
                          hide-details
                          readonly
                        />
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
              </fieldset>

            </v-col>
            <v-col cols="6" class="pr-0">
              <fieldset class="px-2 pb-2 group-border">
                <legend class="px-2">Granted</legend>
                <v-card v-for="(bonus, i) in item.granted" :key="'bt-granted-bonus-' + i" class="mt-2">
                  <v-card-text :class="{'pt-1': !!bonus.name,'pt-2': !bonus.name, 'pb-2': true}">
                    <v-label><small>{{ bonus.name }}</small></v-label>
                    <v-row>
                      <v-text-field
                        class="col-3"
                        label="Type"
                        :value="bonus.type"
                        hide-details
                        readonly
                      />

                      <v-text-field
                        class="col-2"
                        label="Amount"
                        :value="bonus.amount || (bonus.percent + '%')"
                        :suffix="['casino','sport','cash_bonus', 'loyalty'].includes(bonus.type) && bonus.amount ? item.currency : false"
                        hide-details
                        readonly
                      />

                      <v-text-field
                        class="col-2"
                        v-if="bonus.hasOwnProperty('wager')"
                        label="Wager"
                        :value="bonus.wager"
                        hide-details
                        readonly
                      />

                      <v-select
                        v-if="bonus.hasOwnProperty('game_id')"
                        class="col"
                        label="Game"
                        :value="bonus.game_id"
                        :prefix="'#' + bonus.game_id"
                        :items="games"
                        hide-details
                        readonly
                      />

                      <v-checkbox
                        :class="{'mr-3': true, 'pt-0': true, 'mt-0': bonus.hasOwnProperty('game_id'), 'ml-3': bonus.hasOwnProperty('game_id')}"
                        v-if="bonus.hasOwnProperty('provider_exclusive')"
                        label="Exclusive Brand"
                        :value="bonus.provider_exclusive"
                        hide-details
                        readonly
                      />

                      <v-checkbox
                        :class="{'pt-0': true,'mt-0': bonus.hasOwnProperty('game_id')}"
                        v-if="bonus.hasOwnProperty('game_exclusive')"
                        label="Exclusive Game"
                        :value="bonus.game_exclusive"
                        hide-details
                        readonly
                      />
                    </v-row>
                  </v-card-text>
                </v-card>
              </fieldset>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-slot:item.action="{ item }">
        <div style="white-space: nowrap">
          <v-icon small @click="selected = item">
            edit
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
  .package-project_selector {
    max-width: 300px;
  }
</style>


<script>
  import { debounce, filter, get, map, isString, trim } from 'lodash'
  import { API } from '@/utils/api'
  import Benefits from '@/components/bonus-tools/Benefits'
  import moment from 'moment'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {

    components: {
      SelectProject,
      DatePicker,
      Benefits,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      benefitListLoading: false,
      loading: false,

      searching: false,
      account: null,
      accountSearch: '',
      accounts: [],

      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      project: null,
      expanded: [],
      games: [],
      items: [],
      total: 0,
      benefit_list: [],
      benefit_id: null,

      types: [
        { text: 'Period', value: 'period' },
        { text: 'Autobonus', value: 'autobonus' },
        { text: 'Promotional', value: 'promo' },
        { text: 'Cashback', value: 'cashback' },
        { text: 'Retention', value: 'retention' },
        { text: 'Achievement', value: 'achievement' },
        { text: 'Journey', value: 'journey' },
      ],
      type: '',

      filters: {
        package_id: { data: [], type: 'text', width: '120px' },
        login: { data: [], type: 'text' },
        currency: { data: [], type: 'select', width: '100px' },
        // 'rules.recurring': { data: [], type: 'select' },
        manual_check: { data: [], type: 'select', width: '100px' },
        status: { data: [], type: 'select', width: '150px' },

        // ref_id: { data: [], type: 'text' },
        // name: { data: [], type: 'text' },
        // enabled: { data: [], type: 'select', values: [ { text: 'Yes', value: 1 }, { text: 'No', value: 0 } ] },
      },
      headers: [
        { text: 'ID', value: 'package_id' },
        { text: 'Login', value: 'login' },
        { text: 'Currency', value: 'currency' },
        { text: 'Benefit', value: 'benefit' },
        { text: 'Type', value: 'rules.type', sortable: false },
        { text: 'Recurring', value: 'rules.recurring', sortable: false },
        { text: 'Manual Check', value: 'manual_check', sortable: false },
        { text: 'Status', value: 'status' },
        { text: 'Created', value: 'created' },
        { text: 'Updated', value: 'updated' },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
        // { text: '', value: 'action' },
      ],
      options: {},
    }),

    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },

      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },

      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      accountSearch: {
        handler: debounce(function () {

          this.searchReq({ value: this.accountSearch })
          // this.loadGames()
          // this.loadSportBonusTemplates()
        }, 800),
        deep: true,
      },
      project: {
        handler () {
          this.accountSearch = ''
          // this.searchReq({ value: this.accountSearch })
        },
      },
      options: {
        handler () {
          this.search()
        },
        deep: true
      },
    },

    methods: {

      setSearch (e) {
        if (!e) {
          this.accountSearch = ''
        } else if (typeof e === 'string') {
          this.accountSearch = e
        } else if (typeof e === 'object' && e.srcElement) {
          this.accountSearch = e.srcElement.value
        }
      },

      searchReq (params) {
        if (!params.value || !isString(params.value)) return

        params.value = trim(params.value)

        params.minify = true
        this.searching = true

        return API.call('/$v/account/search.json', params, null, this.project).then(resp => {
          this.accounts = resp.data
        }).catch(e => {
        }).finally((r) => {
          this.searching = false
        })
      },

      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },

      search: function () {

        if (typeof this.accountSearch != 'object') {
          this.accountSearch = this.accounts[0]
        }

        if (this.loading == true || !this.accountSearch) {
          return
        }

        this.loading = true

        try {
          API.call('/bonus_tools/packages_list.json', {
            ...this.options,
            account_id: (typeof this.accountSearch == 'object' ? this.accountSearch.value : this.accountSearch),
            with_benefit: true,
            from: this.from,
            to: this.to,
          }, null, this.project).then(resp => {

            this.games = get(resp, 'games', [])
            this.items = get(resp, 'data', [])
            if (get(resp, 'total', false)) {
              this.total = resp.total
            }
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },
    }
  }
</script>
